module.exports = (angularModule) => {

  angularModule.directive('accountSelection', accountSelection);

  function accountSelection() {
    return {
      restrict: 'A',
      scope: {
        accountConfig : '='
      },
      controller: AccountSelectionController,
      controllerAs: 'vm',
      template: '<div ng-if="vm.showAccountSelection" class="full-width">\
                  <input class="accountSelection {{vm.classesToAdd}}" ui-select2="accountSelectOptions" name="account" id="account" ng-disabled="{{vm.selectionDisabled}}"\
                  ng-model="vm.selectedAccount" data-placeholder="{{vm.placeholder}}" required account-validation>\
                  </input>\
                </div>'
    }
  }

  AccountSelectionController.$inject = ['$scope', '$q', 'accountsService','adminPageInfo'];
  function AccountSelectionController($scope, $q, accountsService, adminPageInfo) {
    var vm = this;

    var promises = {
      allAccounts: accountsService.listAccounts(),
      currentAccount: accountsService.getCurrentAccount()
    };

    vm.classesToAdd = $scope.accountConfig.formControl ? "form-control" : "";
    vm.selectionDisabled = $scope.accountConfig.disableDropdown;

    $q.all(promises).then(function (resp) {
      var accounts = resp.allAccounts.accounts;

      $scope.accountConfig.accountNames = {};
      _.each(accounts,function(val){ $scope.accountConfig.accountNames[val.id] = val.accountName; });
      vm.placeholder = $scope.accountConfig.required ? "Select an Account" : "All";

      if($scope.accountConfig.editPage){
        if(resp.currentAccount !== $scope.accountConfig.accountId){
          accountsService.lastSelectedAccount = resp.currentAccount;
          vm.selectedAccount = $scope.accountConfig.accountId;
        }
        else{
          accountsService.lastSelectedAccount = $scope.accountConfig.accountId;
          vm.selectedAccount = resp.currentAccount;
        }
        if(vm.selectedAccount !== "all"){
          vm.selectionDisabled = true;
        }
      }
      else{
        if (accountsService.lastSelectedAccount) {
          if (!accountsService.init) {
            vm.selectedAccount = accountsService.lastSelectedAccount;
          } else {
            if (!adminPageInfo.getPreviousPageInfo().type == 'account') {
              vm.selectedAccount = "all";
              accountsService.lastSelectedAccount = null;
            } else {
              vm.selectedAccount = accountsService.lastSelectedAccount;
            }
            accountsService.init = false;
          }
        } else {
          vm.selectedAccount = "all";
          accountsService.init = false;
        }
      }

      vm.accountList = prependWithDefault(accounts);
      $scope.accountConfig.hasMultipleAccounts = accounts.length > 1;

      $scope.accountConfig.selectedAccountIdOrOnlyAccountId = $scope.accountConfig.hasMultipleAccounts ?
        vm.selectedAccount : accounts[0].id; // TODO this should be `selectedAccountIdOrUsersAccountId` and check for `"all"` as the accountId
      vm.showAccountSelection = $scope.accountConfig.hasMultipleAccounts;
      $scope.accountConfig.showAccountSelection = vm.showAccountSelection;
      setupAccountMonitoring();
    });

    $scope.accountSelectOptions = {
      initSelection : function (element, callback) {
        var account = _.findWhere(vm.accountList, {id: vm.selectedAccount});
        var initObject;
        if(account){
          initObject = {id: account.id, text: account.text};
          callback(initObject);
        }
      },
      query : function (query) {
        accountsService.listAccounts({query:query.term}).then(function (res) {
          var results = prependWithDefault(res.accounts);
          var data = {results: results};
          query.callback(data);
        });
      }
    }

    function prependWithDefault(accounts){
      var results = [];
      var prepend = [];
      if(!$scope.accountConfig.required){
        prepend.push({
          id: "all",
          text: "All"
        });
      }
      _.each(accounts,function(el){
        results.push(
          {
            id: el.id,
            text: el.accountName
          }
        )
      });
      results = _.sortBy(results, function(i){ return i.text.toLowerCase(); });
      var combined = prepend.concat(results);
      return combined;
    }

    function setupAccountMonitoring(){

      $scope.$watch('vm.selectedAccount', function (newVal, oldVal) {
        if(typeof newVal !== "string"){
          return;
        }
        $scope.accountConfig.accountId = newVal;
        accountsService.setCurrentAccount(newVal);
        if (newVal !== oldVal) {
          if(!$scope.accountConfig.editPage){
            accountsService.lastSelectedAccount = newVal;
          }
        }

      });


    }

  }
}
